module.exports = __webpack_public_path__ + "static/media/img5.9cc5a9b7.png";